import React, { useState } from "react";
import PropTypes from "prop-types";

import Accordion from "../accordion/Accordion";
import BenchmarkSection from "./BenchmarkSection.components";
import ModalBenchmarkingSelection from "../benchmarking-project-selection/ModalBenchmarkingSelection";
import isEmpty from "../../validation/is-empty";
import EstimatesSubtotal from "../estimates/EstimatesSubtotal";
import EstimatesTotal from "../estimates/EstimatesTotal";
import { translate, tranStr } from "../../utils/translation";
import "./BenchmarkingProject.css";

import Fab from "@mui/material/Fab";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CustomWidthTooltip from "../muiControls/muiToolTip";
import BenchmarkingLimitationsData from "./BenchmarkingLimitationsData";

// APIs
import { useCurrencyExchange } from "../../api/admin/CurrencyExchangeAPI";
import { useLocations } from "../../api/admin/RegionManagementAPI";
import { useMultiRegionTPI } from "../../api/tender-price-index/TenderPriceIndexingAPI";
import {
  useProjectSettings,
  onSettingsChange,
} from "../../api/projects/ProjectSettingsAPI";

/// props validation | SQ(javascript:S6774)
BenchmarkingProject.propTypes = {
  user: PropTypes.object,
  CP: PropTypes.object,
  CPs: PropTypes.any,
  project: PropTypes.any,
  TPI: PropTypes.any,
  LFI: PropTypes.any,
  accordionState: PropTypes.any,
  benchmarking: PropTypes.any,
  setBenchmarking: PropTypes.func,
  estimateBenchComments: PropTypes.array,
  setEstimateBenchComments: PropTypes.func,

  showDashboardDrawer: PropTypes.bool,
  setShowDashboardDrawer: PropTypes.func,
};
///
export default function BenchmarkingProject(props) {
  // Props
  const { user } = props;
  const { CP } = props;
  const { CPs } = props;
  const { project } = props;
  const { TPI, LFI } = props;
  const { accordionState } = props;
  const { showDashboardDrawer, setShowDashboardDrawer } = props;

  // APIs
  const { currencyExchange } = useCurrencyExchange();
  const { locations } = useLocations(true);

  // All Benchmarking
  const { benchmarking, setBenchmarking } = props;

  // Estimate Benchmark Commentary
  const { estimateBenchComments, setEstimateBenchComments } = props;

  const [showDashboard, setShowDashboard] = useState(false);

  // No Data
  if (isEmpty(CP)) {
    return (
      <div>
        {translate(
          "Cost Plan Benchmarking is available after a Cost Plan has been uploaded"
        )}
      </div>
    );
  }

  const display = [];
  // Estimates Included in the Total
  CP.estimates.forEach((e, i) => {
    if (e.is_included) {
      display.push(
        <div key={"bm" + i}>
          <Benchmark
            e={e}
            user={user}
            CPs={CPs}
            CP={CP}
            project={project}
            TPI={TPI}
            LFI={LFI}
            benchmarking={benchmarking}
            setBenchmarking={setBenchmarking}
            estimateBenchComments={estimateBenchComments}
            setEstimateBenchComments={setEstimateBenchComments}
            accordionState={accordionState}
            currencyExchange={currencyExchange}
            locations={locations}
            showDashboard={showDashboard}
            setShowDashboard={setShowDashboard}
            // Cost Planning Dashboard Drawer
            showDashboardDrawer={showDashboardDrawer}
            setShowDashboardDrawer={setShowDashboardDrawer}
          />
          <EstimatesSubtotal
            project={project}
            estimates={CP.estimates}
            estimateID={e.id}
            subtotal_below={e.subtotal_below}
            subtotal_name={e.subtotal_name}
            subtotal_gfa_override={e.subtotal_gfa_override}
          />
        </div>
      );
    }
  });
  // The Total
  display.push(
    <EstimatesTotal project={project} CP={CP} key={CP.estimates.length} />
  );

  // Estimates Excluded from the Total
  CP.estimates.forEach((e, i) => {
    if (!e.is_included) {
      display.push(
        <div key={"bm" + i}>
          <Benchmark
            e={e}
            user={user}
            CPs={CPs}
            CP={CP}
            project={project}
            TPI={TPI}
            LFI={LFI}
            benchmarking={benchmarking}
            setBenchmarking={setBenchmarking}
            estimateBenchComments={estimateBenchComments}
            setEstimateBenchComments={setEstimateBenchComments}
            accordionState={accordionState}
            currencyExchange={currencyExchange}
            locations={locations}
            showDashboard={showDashboard}
            setShowDashboard={setShowDashboard}
            // Cost Planning Dashboard Drawer
            showDashboardDrawer={showDashboardDrawer}
            setShowDashboardDrawer={setShowDashboardDrawer}
          />
          <EstimatesSubtotal
            project={project}
            estimates={CP.estimates}
            estimateID={e.id}
            subtotal_below={e.subtotal_below}
            subtotal_name={e.subtotal_name}
            subtotal_gfa_override={e.subtotal_gfa_override}
          />
        </div>
      );
    }
  });

  // For each benchmark we want to create an Accordion
  return <div className="estimate-benchmarking">{display}</div>;
}

/// props validation | SQ(javascript:S6774)
Benchmark.propTypes = {
  user: PropTypes.object,
  CP: PropTypes.object,
  CPs: PropTypes.any,
  project: PropTypes.any,
  LFI: PropTypes.any,
  e: PropTypes.object,
  accordionState: PropTypes.any,
  benchmarking: PropTypes.any,
  setBenchmarking: PropTypes.func,

  currencyExchange: PropTypes.any,
  locations: PropTypes.any,

  showDashboardDrawer: PropTypes.bool,
  setShowDashboardDrawer: PropTypes.func,
};
///
function Benchmark(props) {
  // Props
  const { user } = props;
  const { CP } = props;
  const { CPs } = props;
  const { project } = props;
  const { LFI } = props;
  const { e } = props;
  const { accordionState } = props;
  const { currencyExchange } = props;
  const { locations } = props;

  const { showDashboardDrawer, setShowDashboardDrawer } = props;

  // All Benchmarking
  const { benchmarking, setBenchmarking } = props;

  // extract relevant fields from project
  const { unit_of_measure: unitOfMeasure, currency_symbol: currencySymbol } =
    project;

  // extract relevant fields from CP
  const { is_locality_factor_active, locality_factor } = CP;

  // We want to extract the benchmarks for the given project
  let uom = unitOfMeasure;

  let benchmarkName = "";
  let benchmarkRate = "";
  let benchmarkTotal = "";
  let linked_benchmarks = [];
  let benchmarkArea = "";
  const thisBenchmark = e.benchmark;

  if (!isEmpty(thisBenchmark)) {
    benchmarkName =
      thisBenchmark.project_name +
      " - " +
      tranStr("Benchmarking (Construction Costs)");

    benchmarkRate = thisBenchmark.construction_cost_rate;
    benchmarkArea = thisBenchmark.local_region_area;
    benchmarkTotal = Math.round(thisBenchmark.construction_cost);
    linked_benchmarks = thisBenchmark.linked_benchmarks;
  }

  const { settings } = useProjectSettings(project.id);
  const onSettingsToggle = prepareOnSettingsToggle({ project });

  // API
  const { TPI } = useMultiRegionTPI(
    thisBenchmark?.linked_benchmarks,
    locations?.data
  ); // Benchmarks

  return (
    <div className="benchmarking-flex-box">
      <Accordion
        label={benchmarkName}
        local_region_area={benchmarkArea}
        unit={uom}
        rate={benchmarkRate}
        total={benchmarkTotal}
        // State
        accordionState={accordionState}
        accordionSection={"BENCHMARKING"}
        estimateID={e.id}
      >
        <BenchmarkSection
          // Caller
          caller={"COST_PLAN_BENCHMARKING"}
          // Benchmark Data
          thisBenchmark={thisBenchmark}
          benchmarks={linked_benchmarks}
          // General Data
          unitOfMeasure={thisBenchmark?.unitOfMeasure}
          currencySymbol={currencySymbol}
          baseDate={thisBenchmark?.base_date}
          // Location
          region={thisBenchmark?.region}
          country={thisBenchmark?.country}
          city={thisBenchmark?.city}
          // Inflation Escalation
          TPI={TPI}
          // Locality Escalation
          LFI={LFI}
          isLocalRegionFactorEnabled={thisBenchmark?.localRegionFactor}
          is_locality_factor_active={is_locality_factor_active} // Cost Plan Locality Factor Override Toggle
          locality_factor={locality_factor} // Cost Plan Locality Factor Override Value
          // Currency Escalation
          isGlobalBenchmarking={thisBenchmark?.currencyFactor}
          currencyExchange={currencyExchange.data}
          currency={thisBenchmark?.currency}
          // Dashboard
          showDashboard={showDashboardDrawer}
          setShowDashboard={setShowDashboardDrawer}
          moduleId={CP.cost_plan_id}
          // User
          user={user}
          // Anonymisation
          linkedBenchmarksIds={thisBenchmark?.linkedBenchmarksIds}
          linkedBenchmarksIdsParentId={thisBenchmark?.id}
          linkedBenchmarks={linked_benchmarks} // This can be different depending on the location
          updateState={async () => {
            CPs.set(await CPs.get(project.id));
          }}
          // Project Settings
          project={project}
          settings={settings}
          onSettingsToggle={onSettingsToggle}
        />
      </Accordion>
      <ModalBenchmarkingSelection
        user={user}
        projectID={project.id}
        estimate={e}
        estimateID={e.id}
        CPs={CPs}
        CP={CP}
        benchmarkName={benchmarkName}
        benchmarking={benchmarking}
        setBenchmarking={setBenchmarking}
        benchmarkingForBenchmark={linked_benchmarks}
        project={project}
      />
      <div>
        <BenchMarkingLimitations />
      </div>
    </div>
  );
}

function prepareOnSettingsToggle({ project }) {
  return function onSettingsToggle(props) {
    onSettingsChange({ project, ...props });
  };
}

export function BenchMarkingLimitations() {
  return (
    <CustomWidthTooltip title={<BenchmarkingLimitationsData />}>
      <Fab
        sx={{
          position: "fixed",
          top: 157,
          marginLeft: "15px",
          color: "white",
          height: "37px",
          width: "37px",
          bgcolor: "var(--collaboration1)",
          "&:hover": {
            bgcolor: "var(--heritage)",
          },
        }}
      >
        <HelpOutlineIcon sx={{ height: "52px", width: "52px" }} />
      </Fab>
    </CustomWidthTooltip>
  );
}
